'use strict';

import controller from './login.controller';
import template from './login.html';

const LoginComponent = {
    bindings: {},
    controller,
    template
};

export default LoginComponent;


// WEBPACK FOOTER //
// ./src/app/components/admin/login/login.component.js